import React from 'react';
import { SkuSimilarProductsProps } from '@/types/props/components';
import SkusCarouselDesktop from './common/carousels/skus/SkusCarouselDesktop';
import SkusCarouselMobile from './common/carousels/skus/SkusCarouselMobile';

const SimilarProductsDesktop = ({ skus, userId }: SkuSimilarProductsProps) => {
  return <SkusCarouselDesktop skus={skus} userId={userId} />;
};

const SimilarProductsMobile = ({ skus, userId }: SkuSimilarProductsProps) => {
  return <SkusCarouselMobile skus={skus} userId={userId} />;
};

export { SimilarProductsDesktop, SimilarProductsMobile };
